/*
 * Copyright 2022 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  coreServices,
  createServiceFactory,
} from '@backstage/backend-plugin-api';
import { HostDiscovery } from './HostDiscovery';

/**
 * Service discovery for inter-plugin communication.
 *
 * See {@link @backstage/code-plugin-api#DiscoveryService}
 * and {@link https://backstage.io/docs/backend-system/core-services/discovery | the service docs}
 * for more information.
 *
 * @public
 */
export const discoveryServiceFactory = createServiceFactory({
  service: coreServices.discovery,
  deps: {
    config: coreServices.rootConfig,
    logger: coreServices.logger,
  },
  async factory({ config, logger }) {
    return HostDiscovery.fromConfig(config, {
      logger,
      defaultEndpoints: [],
    });
  },
});
